import type { QueryTransactionHistoryListModel } from '@/api/transaction-history/model/transactionHistory'
import { SortTypeEnum } from '@/enums/sortTypeEnum'

/**
 * @description 取引履歴一覧種別
 */
export enum ListTypeEnum {
  SEND = 0,
  RECIPIENT = 1,
}

/**
 * @description 取引履歴一覧表示区分
 */
export enum ListStatusEnum {
  ALL = 0,
  NEW = 1,
}

/**
 * @description 商品情報
 */
export interface ProductInfo {
  productCompanyType: string
  folderID: string
  productID: string
  ownProductCode: string
  ownProductName: string
  ownProductEnglishName: string
}

/**
 * @description 一覧ソート情報
 */
export interface ListSortInfo {
  sort_column: string
  sort: SortTypeEnum
}

/**
 * @description 一覧ページ情報
 */
export interface ListPageInfo {
  page_number: number
  page_size: number
}

export interface State {
  // 一覧種別
  activeListType: ListTypeEnum
  // 一覧状態
  activeListStatus: ListStatusEnum

  // 取引履歴一覧
  transactionHistoryList: QueryTransactionHistoryListModel
  productInfo: ProductInfo
  listSortInfo: ListSortInfo
  currentSortColumnID: string
  listPageInfo: ListPageInfo

  // 請求ロック
  requestLock: boolean
}

export default (): State => ({
  activeListType: ListTypeEnum.SEND,
  activeListStatus: ListStatusEnum.NEW,

  transactionHistoryList: {} as QueryTransactionHistoryListModel,
  productInfo: {} as ProductInfo,
  listSortInfo: { sort: SortTypeEnum.DESC, sort_column: 'sent_date' },
  currentSortColumnID: '',
  listPageInfo: { page_number: 1, page_size: 20 },

  requestLock: false,
})
